(() => {
  if (window.__pamoProductBundleScriptLoaded) return;
  window.__pamoProductBundleScriptLoaded = true;

class ProductBundle extends HTMLElement {
    constructor() {
        super()
        this.activateBtns = this.querySelectorAll('[js-bundle-product-overlay]');
        this.productRemoveBtns = this.querySelectorAll('[js-product-remove-btn]'); 
        this.addToCartBtn = this.querySelector("[js-atc-btn]");
        this.form = this.querySelector("[js-form]");

        if (!this.addToCartBtn) return;

        document.addEventListener("product:variant-change", (evt) => {
            window.bundleInfo.mainProductPrice = evt.detail.variant.price;
            window.bundleInfo.mainProductCompareAtPrice = evt.detail.variant.compare_at_price;

            this.updatePrice();
            this.bundleMainProductChangeVariantIdAndCTABtn(evt.detail.variant);
        });

        this.init()
    }

    init() {
        this.activateBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const productCard = btn.closest('[js-product-card]');
                productCard.classList.add('active');
                this.toggleActivation(btn, true)
                this.updatePrice()
            })
        })

        this.productRemoveBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const productCard = btn.closest('[js-product-card]');
                productCard.classList.remove('active');
                this.toggleActivation(btn, false)
                this.updatePrice()
            })
        })

        this.addToCartBtn.addEventListener("click", (e) => {
            e.preventDefault();
            this.addToCart(this.form, this.addToCartBtn);
        });
    }

    bundleMainProductChangeVariantIdAndCTABtn(selectedVariant) {
        this.querySelector('[js-bundle-main-product]').value = selectedVariant.id;

        const element = this.querySelector('[name="items[1][properties[_pamo_bundle_discount]"]');
        if(selectedVariant.compare_at_price) {
            if (element) element.value = 0;
        } else {
            if (element) element.value = bundleInfo.discount;
        }
       
        if(selectedVariant.available) {
            this.addToCartBtn.classList.remove('disabled')
        } else {
            this.addToCartBtn.classList.add('disabled')
        }
    }

    addToCart(form, submitBtn) {
        const currentTime = new Date().getTime();

        this.querySelectorAll('[js-bundle-id]').forEach(input => {
            input.value = currentTime;
        })

        this.updateDeliveryDaysInput();

        submitBtn.classList.add("loading");
        const data = {
          form,
          submitBtn,
        };

        document.dispatchEvent(
          new CustomEvent("quickAddToCart:init", { detail: data })
        );
    }

    updateDeliveryDaysInput() {
        const deliveryDaysInput = this.querySelector('[js-bundle-delivery-text-input-days]');
        const deliveryLabelInput = this.querySelector('[js-bundle-delivery-text-input-name]');
        if (!deliveryDaysInput || !deliveryLabelInput) return;

        const customDatas = window.bundleProductVariantCustomDatas || {};
        const mainVariantId = this.querySelector('[js-bundle-main-product]')?.value;
        let maxDays = customDatas[mainVariantId]?.deliveryDays || 0;

        this.querySelectorAll('.active[js-product-card]').forEach(productCard => {
            const productId = productCard.getAttribute('data-product-id');
            const position = productCard.getAttribute('data-position');
            const variantIdInput = this.querySelector(`[data-input-variant-id="${productId}_${position}"]`);
            const variantId = variantIdInput?.value;
            const itemDays = customDatas[variantId]?.deliveryDays || 0;
            if (itemDays > maxDays) {
                maxDays = itemDays;
            }
        });

        if (maxDays > 0) {
            deliveryDaysInput.value = maxDays;
            deliveryDaysInput.removeAttribute('disabled');
            deliveryLabelInput.removeAttribute('disabled');
        } else {
            deliveryDaysInput.setAttribute('disabled', true);
            deliveryLabelInput.setAttribute('disabled', true);
        }
    }

    toggleActivation(target, active) {
        const parent = target.closest('[js-product-card]');
        const productId = parent.getAttribute('data-product-id');
        const position = parent.getAttribute('data-position');
        const variantIdInputs = document.querySelectorAll(`product-bundle [data-input-product-id="${productId}_${position}"]`);

        variantIdInputs.forEach(input => {
            if(active) {
                input.removeAttribute('disabled')
            } else {
                input.setAttribute('disabled', true)
            }
        })
    }

    updatePrice() {
        const bundleInfo = window.bundleInfo;

        const productCards = this.querySelectorAll('.active[js-product-card]');

        let bundleOriginalPrice = bundleInfo.mainProductPrice;

        let mainProductDiscountedPrice =  ((100 - bundleInfo.discount) / 100 * bundleInfo.mainProductPrice);
        let mainChildBundleProductsDiscountedPrice = 0;

        if(bundleInfo.mainProductCompareAtPrice) {
            bundleOriginalPrice = bundleInfo.mainProductCompareAtPrice;
            mainProductDiscountedPrice = bundleInfo.mainProductPrice;
        }

        productCards.forEach(productCard => {
          const variantPrice = parseFloat(productCard.getAttribute('data-current-variant-price')); 

          let variantCompareAtPrice = 0;
          if(productCard.getAttribute('data-current-variant-compare-at-price')) {
            variantCompareAtPrice = parseFloat(productCard.getAttribute('data-current-variant-compare-at-price'));
          }
          
          if(variantCompareAtPrice) {
            bundleOriginalPrice += variantCompareAtPrice;
            mainChildBundleProductsDiscountedPrice += variantPrice;
          } else {
            bundleOriginalPrice += variantPrice;
            mainChildBundleProductsDiscountedPrice += ((100 - bundleInfo.discount) / 100 * variantPrice);
          }
          
        })
  
        let bundleDiscountPrice = mainProductDiscountedPrice + mainChildBundleProductsDiscountedPrice;
  
        const formatMoney = (val => this.formatMoney(val, window.theme.moneyFormat || '${{amount}}'));
  
        this.querySelectorAll('[js-bundle-product-discounted-price]').forEach(priceTag => {
          priceTag.innerHTML = `${formatMoney(bundleDiscountPrice)}`
        })

        this.querySelectorAll('[js-bundle-product-original-price]').forEach(priceTag => {
            priceTag.innerHTML = `${formatMoney(bundleOriginalPrice)}`
        })

        this.disableATC();
        
      }

      disableATC() {
        const productCards = this.querySelectorAll('.active[js-product-card]');

        if(productCards.length == 0) {
            this.addToCartBtn.classList.add('disabled')
        } else {
            this.addToCartBtn.classList.remove('disabled')
        }
      
      }

    formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        let value = '';
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        const formatString = format || moneyFormat;
        
        function formatWithDelimiters(
            number,
            precision = 2,
            thousands = ',',
            decimal = '.'
        ) {
            if (isNaN(number) || number == null) {
            return 0;
            }
        
            number = (number / 100.0).toFixed(precision);
        
            const parts = number.split('.');
            const dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            `$1${thousands}`
            );
            const centsAmount = parts[1] ? decimal + parts[1] : '';
        
            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
            case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
            case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
            case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        }
        
        return formatString.replace(placeholderRegex, value);
    }

}

if (!customElements.get('product-bundle')) {
    customElements.define('product-bundle', ProductBundle);
}
})();